import React from 'react'

function Box() {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.48} fill="#fff">
        <path
          d="M.5 3a.5.5 0 01.5-.5h22a.5.5 0 01.5.5v4.5H.5V3z"
          stroke="#fff"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 9H1v13h22V9zm-7 2H8v2h8v-2z"
        />
      </g>
    </svg>
  )
}

export default React.memo(Box)
